// extracted by mini-css-extract-plugin
module.exports = {"eventCancelled":"eventName_eventCancelled__u4SSW"};